import { useState } from "react";
import { useLocation } from "react-router-dom";
import { recordConsent } from "@/lib/policyConsent";

/** "I have read and agree" checkbox + button; each agreement is recorded. */
export default function PolicyAgree() {
  const { pathname } = useLocation();
  const policy = pathname.replace(/^\//, "") || "policy";
  const key = `wekit-policy-agreed:${policy}`;
  const [checked, setChecked] = useState(false);
  const [done, setDone] = useState(() => {
    try { return Boolean(localStorage.getItem(key)); } catch { return false; }
  });
  const [busy, setBusy] = useState(false);

  const agree = async () => {
    setBusy(true);
    await recordConsent({ kind: "policy", policy, choice: "agreed" });
    try { localStorage.setItem(key, new Date().toISOString()); } catch { /* ignore */ }
    setBusy(false);
    setDone(true);
  };

  return (
    <section aria-label="Your agreement" className="mt-8 border border-border bg-muted/40 p-4">
      {done ? (
        <p className="text-sm font-medium" role="status">Thank you. Your agreement to this policy has been recorded.</p>
      ) : (
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <label className="flex cursor-pointer items-start gap-2 text-sm">
            <input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} className="mt-0.5 h-4 w-4 accent-primary" />
            I have read and agree to this policy.
          </label>
          <button
            type="button"
            disabled={!checked || busy}
            onClick={agree}
            className="min-h-11 bg-primary px-5 text-sm font-medium text-primary-foreground hover:bg-primary/90 disabled:opacity-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
          >
            {busy ? "Saving…" : "Accept and agree"}
          </button>
        </div>
      )}
    </section>
  );
}
